import type { OrderChatHistory } from './ymarket-chat'

export interface PendingChatDeliveryVerification {
  text: string
  sentAt?: string
  afterMessageId?: number
}

function normalizeChatMessage(text: string): string {
  return text
    .normalize('NFKC')
    // Market may preserve Markdown in the send response but return the same
    // message from history after stripping emphasis markers.
    .replace(/[*_~`]/g, '')
    .replace(/\s+/g, ' ')
    .trim()
}

/** Client-safe delivery verification; intentionally separate from the server-only Yandex transport. */
export function chatContainsSentMessage(history: OrderChatHistory, text: string, sentAt: string, afterMessageId = 0): boolean {
  const expected = normalizeChatMessage(text)
  const threshold = Date.parse(sentAt) - 60_000
  return history.messages.some(entry => entry.sender === 'PARTNER'
    && entry.messageId > afterMessageId
    && Boolean(entry.message)
    && normalizeChatMessage(entry.message!) === expected
    && (Number.isNaN(threshold) || Date.parse(entry.createdAt) >= threshold))
}

/** Keep the read-only reconciliation predicate shared by polling and manual refresh. */
export function historyConfirmsPendingChatDelivery(
  history: OrderChatHistory,
  pending: PendingChatDeliveryVerification,
): boolean {
  return pending.sentAt !== undefined
    && chatContainsSentMessage(history, pending.text, pending.sentAt, pending.afterMessageId)
}
